const getWindow = (): Window => window;

declare global {
  interface Window {
    _satellite: any;
    bootstrapAuth0LoginServlet: () => void;
    auth0Config: any;
    passwordlessWebAuth: any;
    fontBaseURL: string; // This is set in the login.ejs file!
    csrfToken: string;
    resetPasswordTicket: string;
    username: string;
  }
}

export { getWindow };
